<div class="editor-container">
  <input
    id="diagram-title"
    name="diagram-title"
    type="text"
    class="diagram-title-input"
    aria-label="Titre du diagramme"
    [value]="_editorService.diagramTitle$ | async"
    (input)="onTitleChange($event)"
    placeholder="Titre du diagramme" />

  <textarea
    id="diagram-content"
    name="diagram-content"
    class="diagram-content-textarea"
    aria-label="Contenu du diagramme"
    rows="30"
    cols="60"
    [value]="_editorService.diagramText$ | async"
    (input)="onContentChange($event)"
    placeholder="actor NomActeur
    entity NomEntité
    Source -> Destination: Message

   💡 Besoin d'aide pour la syntaxe? Cliquez sur 'Aide' pour plus d'informations.">
  </textarea>
</div>
